jQuery(document).ready(function ( $ ) {
$('.articles_slider').slick({
	  slidesToShow: 3,
	  arrows:false,
	  autoplay:false,
	  responsive: [
	    {
	      breakpoint: 959,
	      settings: {
	        slidesToShow: 2
	      }
	    },
	    {
	      breakpoint: 575,
	      settings: {
	        slidesToShow: 1,
	      }
	    }
	  ]
	});
})